module.exports = __webpack_public_path__ + "img/ticket.ab079ea.svg";